export default class Quantity {
  constructor(el) {
    this.$el = $(el);
    this.$input = this.$el.find('[data-quantity-input]');
    this.$decrement = this.$el.find('[data-quantity-decrement]');
    this.$increment = this.$el.find('[data-quantity-increment]');

    this.events = [
      this.$input.on('change.quantity', event => this.change(this.value)),
      this.$decrement.on('click.quantity', event => this.change(this.value - 1)),
      this.$increment.on('click.quantity', event => this.change(this.value + 1)),
    ];

    this._updateButtonState();
  }

  unload() {
    this.events.forEach($el => $el.off('.quantity'));
  }

  get input() {
    return this.$input.get(0);
  }

  get value() {
    return parseInt(this.$input.val(), 10) || 0;
  }

  get range() {
    const min = parseInt(this.$input.attr('min'), 10) || 0;
    const max = parseInt(this.$input.attr('max'), 10) || Infinity;
    return { min, max };
  }

  change(value, trigger = true) {
    const range = this.range;
    const currentValue = this.value;

    if (value > range.max) {
      value = range.max;
    }

    if (value < range.min) {
      value = range.min;
    }

    if (value !== currentValue) {
      this.$input.val(value);
    }

    if (trigger && value !== currentValue) {
      this.$input.trigger('change');
    }

    this._updateButtonState();
  }

  _updateButtonState() {
    const value = this.value;
    const range = this.range;

    this.$decrement.prop('disabled', value <= range.min);
    this.$increment.prop('disabled', value >= range.max);
  }
}
